import React from 'react';

const AreaRenderer = ({
  rowData,
  rowData: { summarized, projectLocationId, shiftLocationId },
  columnData: { mappedLocations, key = 'locationId' }
}) => {
  const locationId = rowData?.[key];
  if (summarized || (!locationId && !projectLocationId)) {
    return <></>;
  }
  if (shiftLocationId && projectLocationId && shiftLocationId !== projectLocationId) {
    return <>{`${mappedLocations[shiftLocationId]?.name} - ${mappedLocations[projectLocationId]?.name}`}</>;
  }

  return <>{mappedLocations[locationId]?.name || mappedLocations[projectLocationId]?.name || ''}</>;
};

export default AreaRenderer;
